import type { ImageWidget } from "~/types/widgets"

/** @title Imagem */
export interface IImage {
    /**
     * @title Imagem
     */
    src: ImageWidget

    /**
     * @title Texto alternativo
     */
    alt?: string
}

export interface Props {
    /**
     * @title Texto
     * @format html
     */
    text: string

    /**
     * @title Imagem
     */
    image?: IImage

    /**
     * @title Imagem de fundo
     */
    backgroundImage?: ImageWidget
}

export default function Content({ text, image, backgroundImage }: Props) {
    if (!text) return null

    return (
        <div
            className={backgroundImage
                ? 'bg-center bg-cover bg-no-repeat bg-fixed lg:bg-scroll'
                : 'bg-[#e5554f]'}
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className='max-w-[960px] py-12 px-2 mx-auto font-lato grid justify-items-center items-center gap-24 lg:px-0 lg:grid-cols-2 lg:gap-6'>
                <div
                    className='text-white text-[19px] text-center leading-7 [&_h1]:text-[36px] [&_h1]:leading-snug [&_h1]:font-black [&_h1]:resale-lingerie-scale-animation [&_h2]:text-[54px] [&_h2]:leading-snug [&_h2]:font-black [&_h2]:resale-lingerie-scale-animation [&_h3]:text-[33px] [&_h3]:leading-snug [&_h3]:font-black [&_h3]:resale-lingerie-scale-animation lg:text-left'
                    dangerouslySetInnerHTML={{ __html: text }}
                />

                {image && (
                    <img
                        src={image?.src}
                        alt={image?.alt}
                        width={460}
                        height={460}
                        loading='lazy'
                    />
                )}
            </div>
        </div>
    )
}
